import { Component, OnInit } from '@angular/core';
import {PostsService} from '../common/services/posts.service';
import {PostDO} from '../common/data-objects/PostDO';
import {ToastrService} from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-coloring-section-page',
  templateUrl: './coloring-section-page.component.html',
  styleUrls: ['./coloring-section-page.component.scss']
})
export class ColoringSectionPageComponent implements OnInit {
  posts: PostDO[];
  page: number;
  isLoading: boolean;
  searchText: string;
  pagesCount: number;
  itemsCount: number;
  private queryParamsSubscription: Subscription;

  constructor(
    private postsService: PostsService,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private seoService: SeoService
  ) {
    this.seoService.setTitle('Planșe de colorat pe teme biblice - Fun Bible');
    this.seoService.setDescription('Planșe de colorat pe diverse teme biblice pentru copii. Peste 200 de desene din care copilul isi poate alege pentru a colora');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/coloring/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/coloring.png' });
    const initialKeywords = ['culori', 'planse de colorat biblice', 'imagini de colorat', 'desene de desenat', 'fise de colorat crestine', 'creioane colorate', 'plansa de colorat', 'fisa de colorat', 'desene', 'desene colorate'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Coloring',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.page = Number(queryParams.get('page')) || 1;

      this.getData();
    });
  }

  search() {
    this.onPageChange(1);
  }

  getData() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }

    this.isLoading = true;
    this.postsService.getColoringPages(this.searchText, this.page).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }

  resetSearch() {
    this.searchText = '';
    this.search();
  }

  onPageChange(page: number) {
    this.page = page;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.page
      },
      queryParamsHandling: 'merge',
    });
    this.getData();
  }
}
